import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import { ds, sidebarGradient } from "../theme/keeperTheme";
import { loginByPin } from "../api";
import { saveClientSession } from "../authSession";

/** Клиент: вход по ПИН-коду (роль USER в API); поле маскируется как пароль. */

const ROW1 = [7, 8, 9];
const ROW2 = [4, 5, 6];
const ROW3 = [1, 2, 3];

export default function Login() {
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDigit = (d) => {
    if (pin.length >= 8) return;
    setPin((prev) => prev + String(d));
    setError("");
  };

  const handleBackspace = () => {
    setPin((prev) => prev.slice(0, -1));
  };

  const handleSubmit = async () => {
    if (!pin) {
      setError("Введите пин-код");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const data = await loginByPin(pin);
      saveClientSession({ token: data.access_token, user: data.user });
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message || "Неверный пин-код");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: sidebarGradient,
        color: ds.text,
        p: 2,
      }}
    >
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700, color: ds.text }}>
        Вход
      </Typography>
      <TextField
        label="Код входа"
        value={pin.replace(/./g, "•")}
        InputProps={{ readOnly: true }}
        sx={{
          mb: 2,
          width: "100%",
          maxWidth: 280,
          "& .MuiOutlinedInput-root": {
            bgcolor: ds.surface,
            color: ds.text,
            fontSize: "1.25rem",
            letterSpacing: "0.25em",
          },
          "& .MuiInputLabel-root": { color: ds.text2 },
        }}
      />
      {error && (
        <Alert severity="error" sx={{ mb: 2, width: "100%", maxWidth: 280 }}>
          {error}
        </Alert>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          maxWidth: 280,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 1,
          }}
        >
          {ROW1.map((d) => (
            <Button
              key={d}
              variant="contained"
              onClick={() => handleDigit(d)}
              disabled={loading}
              sx={{
                bgcolor: ds.surface,
                color: ds.text,
                border: `1px solid ${ds.border2}`,
                boxShadow: ds.shadowXs,
                fontSize: "1.25rem",
                fontWeight: 700,
                py: 1.5,
                "&:hover": { bgcolor: ds.primarySoft, borderColor: ds.primary },
              }}
            >
              {d}
            </Button>
          ))}
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 1,
          }}
        >
          {ROW2.map((d) => (
            <Button
              key={d}
              variant="contained"
              onClick={() => handleDigit(d)}
              disabled={loading}
              sx={{
                bgcolor: ds.surface,
                color: ds.text,
                border: `1px solid ${ds.border2}`,
                boxShadow: ds.shadowXs,
                fontSize: "1.25rem",
                fontWeight: 700,
                py: 1.5,
                "&:hover": { bgcolor: ds.primarySoft, borderColor: ds.primary },
              }}
            >
              {d}
            </Button>
          ))}
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 1,
          }}
        >
          {ROW3.map((d) => (
            <Button
              key={d}
              variant="contained"
              onClick={() => handleDigit(d)}
              disabled={loading}
              sx={{
                bgcolor: ds.surface,
                color: ds.text,
                border: `1px solid ${ds.border2}`,
                boxShadow: ds.shadowXs,
                fontSize: "1.25rem",
                fontWeight: 700,
                py: 1.5,
                "&:hover": { bgcolor: ds.primarySoft, borderColor: ds.primary },
              }}
            >
              {d}
            </Button>
          ))}
        </Box>
        <Box
          sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 1 }}
        >
          <Button
            variant="contained"
            onClick={() => handleDigit(0)}
            disabled={loading}
            sx={{
              bgcolor: ds.surface,
              color: ds.text,
              border: `1px solid ${ds.border2}`,
              boxShadow: ds.shadowXs,
              fontSize: "1.25rem",
              fontWeight: 700,
              py: 1.5,
              "&:hover": { bgcolor: ds.primarySoft, borderColor: ds.primary },
            }}
          >
            0
          </Button>
          <Button
            variant="contained"
            onClick={handleBackspace}
            disabled={loading || !pin}
            sx={{
              bgcolor: ds.surface,
              color: ds.text2,
              border: `1px solid ${ds.border2}`,
              boxShadow: ds.shadowXs,
              "&:hover": { bgcolor: ds.surface3, borderColor: ds.border2 },
            }}
          >
            ⌫
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading || !pin}
            sx={{
              bgcolor: ds.primary,
              color: ds.surface,
              fontWeight: 700,
              py: 1.5,
              "&:hover": { bgcolor: ds.primaryHover },
            }}
          >
            ВОЙТИ
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
